import { render, staticRenderFns } from "./block-access.vue?vue&type=template&id=76996499&scoped=true&"
import script from "./block-access.vue?vue&type=script&lang=js&"
export * from "./block-access.vue?vue&type=script&lang=js&"
import style0 from "./block-access.vue?vue&type=style&index=0&id=76996499&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76996499",
  null
  
)

export default component.exports